"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.syncUserForFolder = exports.syncUser = exports.deleteContentFavorite = exports.createContentFavorite = void 0;
const baseUserDto_1 = require("../../dtos/baseUserDto");
const ContentFavoriteDto_1 = require("../../dtos/ContentFavoriteDto");
const internalAxios_1 = require("./internalAxios");
const createContentFavorite = async (contentFavorite) => {
    if (typeof contentFavorite === 'undefined') {
        return;
    }
    const { data } = await internalAxios_1.internalAxios.post('/api/content/favorite', {
        contentFavorite,
    });
    return new ContentFavoriteDto_1.ContentFavoriteDto(data);
};
exports.createContentFavorite = createContentFavorite;
const deleteContentFavorite = async (contentFavoriteId) => {
    const response = await internalAxios_1.internalAxios.delete(`/api/content/favorite/${contentFavoriteId}`);
    return response.status === 204;
};
exports.deleteContentFavorite = deleteContentFavorite;
const syncUser = async (reports) => {
    if (reports.length) {
        return await syncReportUsers(reports);
    }
    return [];
};
exports.syncUser = syncUser;
const syncUserForFolder = async (folders) => {
    if (folders.length) {
        const userIds = folders
            .map((report) => report.creatorId)
            .filter((value, index, self) => self.indexOf(value) === index);
        const reportUsers = await getUsersForReports(userIds);
        folders.forEach((folder) => {
            const user = reportUsers.find((x) => x.id === folder.creatorId);
            folder.createdBy = `${user?.displayName ?? ''}`;
        });
        return folders;
    }
    return [];
};
exports.syncUserForFolder = syncUserForFolder;
const syncReportUsers = async (reports) => {
    const userIds = reports
        .map((report) => report.userId)
        .filter((value, index, self) => self.indexOf(value) === index);
    const reportUsers = await getUsersForReports(userIds);
    return mapReportUser(reports, reportUsers);
};
const getUsersForReports = async (userIds) => {
    const { data } = await internalAxios_1.internalAxios.post(`/api/content/users`, userIds);
    return data.map((user) => new baseUserDto_1.BaseUserDto(user));
};
const mapReportUser = (reports, reportUsers) => {
    reports.forEach((report) => {
        const user = reportUsers.find((x) => x.id === report.userId);
        report.userName = `${user?.displayName ?? ''}`;
    });
    return reports;
};
